import React from 'react';
import SortButton from './SortButton';

class Sort extends React.Component {

  render() {
    return (
      <div className={`brews-sort ${ this.props.sortDirection === 'asc' ? 'brews-sort--asc' : 'brews-sort--desc'}`}>
        <div className="brews-sort__sidelabel">
          <i className="material-icons">unfold_more</i>
        </div>
        <div className="brews-sort__column brews-sort__column--primary">
          <SortButton
            sort={ this.props.sort }
            type="rating"
            label="Rating"
            onClick={ () => this.props.changeSort('rating') }
          />
        </div>
        <div className="brews-sort__column brews-sort__column--secondary">
          <SortButton
            sort={ this.props.sort }
            type="name"
            label="Name"
            onClick={ () => this.props.changeSort('name') }
          />
          <SortButton
            sort={ this.props.sort }
            type="origin"
            label="Origin"
            onClick={ () => this.props.changeSort('origin') }
          />
        </div>
        <div className="brews-sort__column brews-sort__column--tertiary">
          <SortButton
            sort={ this.props.sort }
            type="brew_date"
            label="Brew date"
            onClick={ () => this.props.changeSort('brew_date') }
          />
        </div>
      </div>
    )
  }
}

export default Sort;
